import { render, staticRenderFns } from "./ResidenzaBlock.vue?vue&type=template&id=925234b4"
import script from "./ResidenzaBlock.vue?vue&type=script&lang=js"
export * from "./ResidenzaBlock.vue?vue&type=script&lang=js"
import style0 from "./ResidenzaBlock.vue?vue&type=style&index=0&id=925234b4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports